<script>
	import { getContext } from 'svelte';
	import { TABS } from './Tabs.svelte';

	let { children } = $props();

	const panel = {};
	const { registerPanel, selectedPanel } = getContext(TABS);

	registerPanel(panel);
</script>

{#if $selectedPanel === panel}
	{@render children?.()}
{/if}
